export default "__VITE_ASSET__R9T8Ld7f__"